import { useCountUp } from "@/hooks/useCountUp";
import { formatINR, formatPercent } from "@/lib/utils";

interface AnimatedValueProps {
  value: number;
  format: "inr" | "percent";
  duration?: number;
  enabled?: boolean;
  className?: string;
}

/**
 * Renders an animated count-up number formatted as INR or percent.
 */
export function AnimatedValue({
  value,
  format,
  duration = 1500,
  enabled = true,
  className,
}: AnimatedValueProps) {
  const animated = useCountUp(value, duration, enabled);
  const formatted =
    format === "inr" ? formatINR(animated) : formatPercent(animated);

  return <span className={className}>{formatted}</span>;
}
